import React from 'react';
import { Link } from 'react-router-dom';

import { useState } from 'react';

import { useTranslation } from 'react-i18next';
import AuthPages from '../components/AuthPages';
import Banner from '../components/Banner';
import AuthDecoration from '../images/auth-decoration.png';
import AuthImage from '../images/Slide02.webp';
import TemplatePage from './TemplatePage';
import { handleClick } from '../components/Utils';

function Signup() {
  const { t } = useTranslation();

  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [password, setPassword] = useState("");
  const [company, setCompany] = useState("");
  const [disableButton, setDisableButton] = useState(false);
  const [passwordMessage, setPasswordMessage] = useState("");

  // Bot detection: honeypot field and time-based validation
  const [honeypot, setHoneypot] = useState("");
  const [loadTime] = useState(Date.now());


  const [passwordError, setPasswordError] = useState({
    password: '',
    confirmPassword: ''
  })

  const [input, setInput] = useState({
    password: '',
    confirmPassword: ''
  });


  const onInputPasswordChange = e => {
    const { name, value } = e.target;
    setInput(prev => ({
      ...prev,
      [name]: value
    }));
    validateInput(e);
  }

  const validateInput = e => {

    let { name, value } = e.target;


    setPasswordError(prev => {
      const stateObj = { ...prev, [name]: "" };

      switch (name) {

        case "password":
          if (!value) {
            stateObj[name] = t("auth.passwordEmpty");
          } else if (value.length < 8) {
            stateObj[name] = t("auth.passwordLength");
          } else if (input.confirmPassword && value !== input.confirmPassword) {
            stateObj[name] = t("auth.passwordNOtMatch");
          } else {
            stateObj[name] = input.confirmPassword ? "" : passwordError.confirmPassword;
          }
          break;

        case "confirmPassword":
          if (!value) {
            stateObj[name] = t("auth.passwordRepeatEmpty");
          } else if (input.password && value !== input.password) {
            stateObj[name] = t("auth.passwordNOtMatch");
          } else {
            stateObj[name] = "";
            setPassword(input.password)
          }
          break;

        default:
          break;
      }
      setPasswordMessage(stateObj[name]);


      return stateObj;
    });
  }

  const register = (event) => {
    event.preventDefault();
    setDisableButton(true);

    // Bot detection check
    const submitTime = Date.now();
    if (honeypot !== "" || (submitTime - loadTime < 3000)) {
      console.warn("Possible bot registration detected. Aborting request silently.");
      // Fake a success message to fool the bot into thinking it worked
      setErrorMessage({ ...errorMessage, type: "success", message: t("auth.created"), open: true });
      setDisableButton(false);
      event.target.reset();
      return;
    }

    if (email === "" || name === "" || lastName === "" || password === "" || company === "") {
      setErrorMessage({ ...errorMessage, type: "warning", message: t("auth.noData"), open: true });
      setDisableButton(false);
      return;
    }

    fetch(`${process.env.REACT_APP_REGISTER}`, {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        // Authorization: `Bearer ${UserService.getToken()}`,
      },
      body: JSON.stringify({ name: name, surname: lastName, password: password, email: email, companyName: company, userType: "Representante empresarial" })
    })
      .then(j => j.json())
      .then(r => {
        setDisableButton(false);


        if (r !== null) {
          const error = r.message;
          if (error === "Error creating the user. Keycloak response status 409") {
            setErrorMessage({ ...errorMessage, type: "error", message: t("auth.emailExists"), open: true });
          } else if (error === "Account is not fully set up") {
            setErrorMessage({ ...errorMessage, type: "error", message: t("auth.noFullySetUp"), open: true });
          } else {
            setEmail("");
            setName("");
            setLastName("");
            setCompany("")
            setPassword("");
            event.target.reset();
            setErrorMessage({ ...errorMessage, type: "success", message: t("auth.created"), open: true });
          }
          return;
        }

      }
      ).catch(error => {
        setErrorMessage({ ...errorMessage, type: "error", message: t("auth.error"), open: true });
        setDisableButton(false)

      });

  }

  const [errorMessage, setErrorMessage] = useState({
    type: '',
    message: '',
    open: false,
  });

  const cleanMessage = () => {
    setErrorMessage({ ...errorMessage, type: "", message: "", open: false });
  }
  const setOpen = (value) => {
    setErrorMessage({ ...errorMessage, open: value });

  }


  return (
    <TemplatePage
      h1={t("meta.register.title")}
      title={t("meta.register.title")}
      desc={t("meta.register.description")}
      image={AuthImage}>

      <AuthPages image={AuthImage} decoration={AuthDecoration}>
        <h2 className="text-3xl text-airco2-general font-bold mb-6">{t("auth.titleRegister")} ✨</h2>
        <Banner type={errorMessage.type} children={errorMessage.message} open={errorMessage.open} setOpen={setOpen} className="mb-3 w-ful"></Banner>

        {/* Form */}
        <form onSubmit={register} className='text-airco2-general ' >
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-1" htmlFor="email">{t("auth.email")} <span className="text-red-500">*</span></label>
              <input id="email" className=" w-full bg-white form-user-data" type="email" defaultValue={email} required onChange={(e) => { cleanMessage(); setEmail(e.target.value) }} />
            </div>
            <div className>
              <label className="block text-sm font-medium mb-1" htmlFor="name">{t("auth.name")} <span className="text-red-500">*</span></label>
              <input id="name" className="form-user-data w-full bg-white" type="text" required defaultValue={name} onChange={(e) => { cleanMessage(); setName(e.target.value) }} />
            </div>
            <div className>
              <label className="block text-sm font-medium mb-1" htmlFor="lastName">{t("auth.lastName")} <span className="text-red-500">*</span></label>
              <input id="lastName" className="form-user-data w-full bg-white" type="text" required defaultValue={lastName} onChange={(e) => { cleanMessage(); setLastName(e.target.value) }} />
            </div>
            <div className>
              <label className="block text-sm font-medium mb-1" htmlFor="company">{t("auth.company")} <span className="text-red-500">*</span></label>
              <input id="company" className="form-user-data w-full bg-white" type="text" required defaultValue={company} onChange={(e) => { cleanMessage(); setCompany(e.target.value) }} />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1" htmlFor="password">{t("auth.password")} <span className="text-red-500">*</span></label>
              <input id="password" className="form-user-data w-full bg-white" name="password" type="password" required defaultValue={password} autoComplete="on" onChange={e => onInputPasswordChange(e)} onBlur={validateInput} />
              {passwordMessage !== "" && <p className="mt-2 text-xs text-red-600 dark:text-green-400"><span className="font-medium"> {passwordMessage} </span> </p>}
            </div>

            <div>
              <label className="block text-sm font-medium mb-1" htmlFor="password-repeat">{t("auth.passwordRepeat")} <span className="text-red-500">*</span></label>
              <input id="password-repeat" className="form-user-data w-full bg-white" name="confirmPassword" type="password" defaultValue={password} required autoComplete="off" onChange={e => onInputPasswordChange(e)} onBlur={validateInput} />
            </div>

            <div>
              <label className="flex items-center font-medium">
                <input type="checkbox" className="form-checkbox" required />
                <span className="text-sm ml-2">{t("auth.conditions")} <a href="/legal">{t("auth.terms")} </a><span className="text-red-500" >*</span></span>
              </label>
            </div>

            {/* Honeypot field for bot detection (hidden from real users) */}
            <div style={{ opacity: 0, position: 'absolute', top: '-9999px', left: '-9999px', zIndex: -1 }} aria-hidden="true">
              <label htmlFor="website">Website</label>
              <input id="website" name="website" type="text" value={honeypot} onChange={(e) => setHoneypot(e.target.value)} tabIndex="-1" autoComplete="off" />
            </div>

          </div>
          <div className=" mt-6">
            <button className="btn bg-airco2-principal text-white  whitespace-nowrap w-full" type="submit" disabled={disableButton}>

              {disableButton ? <svg role="status" className="inline mr-3 w-4 h-4 text-white animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB" />
                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor" />
              </svg> : t("auth.register")}
            </button>
          </div>
        </form>
        {/* Footer */}
        <div className="pt-5 mt-6 border-t border-gray-200 text-center">
          <div className="text-sm text-airco2-filter-content">
            {t("auth.hasAccount")} <Link onClick={handleClick} className="font-medium text-airco2-secondary hover:text-blue-600" to="/login">{t("auth.login")} </Link>
          </div>
        </div>

      </AuthPages>
    </TemplatePage>
  );
}

export default Signup;